<template>
  <div>
    <div
      key="0"
      class="row table-title-row d-flex justify-content-between"
    >
      <div class="col-2 label">
        {{ $t('view-Payments.list.id') }}
      </div>
      <div class="col-3 label">
        {{ $t('view-Payments.list.date') }}
      </div>
      <div class="col-3 label">
        {{ $t('view-Payments.list.brand') }}
      </div>
      <div class="col-3 label">
        {{ $t('view-Payments.list.campaign') }}
      </div>
      <div class="col-3 label">
        {{ $t('view-Payments.list.type') }}
      </div>
      <div class="col-2 label">
        {{ $t('view-Payments.list.amount') }}
      </div>
      <div class="col-3 label">
        {{ $t('view-Payments.list.status') }}
      </div>
    </div>
    <transition-group
      name="fade"
      tag="div"
      class="table-content"
    >
      <div
        v-for="item in list"
        :key="item.id"
        class="row d-flex justify-content-between"
      >
        <div class="col-2 item">
          #{{ item.id }}
        </div>
        <div class="col-3 item">
          <span>
            {{ $dateString(item.created_at)[0].replace(/\./g, '/') }}<br>
            <small>{{ $dateString(item.created_at)[1] }}</small>
          </span>
        </div>
        <div class="col-3 item justify-content-center text-center">
          <span v-if="item.payer && item.payer.advertiser">
            <div
              v-lazy-container="{ selector: 'img', loading: emptyAvatar, error: emptyAvatar }"
              class="avatar"
            >
              <img :data-src="item.payer.avatar">
            </div>
            {{ item.payer.name }}
          </span>
          <span v-else>
            ---
          </span>
        </div>
        <div class="col-3 item">
          {{ item.campaign ? item.campaign.name : '---' }}
        </div>
        <div class="col-3 item">
          {{ $t('payment.type.' + item.type) }}
        </div>
        <div class="col-2 item">
          {{ item.price }} {{ $currencySymbol(item.currency) }}
        </div>
        <div class="col-3 item">
          <status-label :status="item.status" />
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import statusLabel from './StatusLabel'

export default {
  components: {
    'status-label': statusLabel
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    emptyAvatar () {
      return `${this.$publicPath}img/profile/empty_avatar.jpg`
    }
  }
}
</script>
